// extracted by mini-css-extract-plugin
module.exports = {"buttons":"i_W"};